import { render } from "./Movie.vue?vue&type=template&id=1e2114ba&ts=true"
import script from "./Movie.vue?vue&type=script&lang=ts"
export * from "./Movie.vue?vue&type=script&lang=ts"

import "./Movie.vue?vue&type=style&index=0&id=1e2114ba&lang=scss"

import exportComponent from "/home/runner/work/chronicle/chronicle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__